module.exports = __webpack_public_path__ + "static/media/9_PR_Mavis Chan.2891acd1.jpeg";